import React from 'react';
import { useLocation } from 'react-router-dom';
import InventorySideBar from "../Components/Sidebar/InventorySideBar"
const InventorySideLayout = ({ children }) => {
  const location = useLocation();
  const isSidebarEnabled = location.pathname.startsWith('/Inventory');
  
  return (
    <div className="sidebar-layout">
      <div className={`sidebar ${isSidebarEnabled ? 'fixed-lefty' : ''}`}>
         <InventorySideBar currentPath={location.pathname} />
      </div>
      <main className="main-content">{children}</main>
    </div>
  )
}

export default InventorySideLayout;